module.exports = __webpack_public_path__ + "img/1-3-mallorca-film-comission.c516995c.png";